import { useNavigate } from "react-router-dom";
import { Truck } from "lucide-react";

export default function AtajoSurtirCedis({ orden, compacto = false }) {
  const navigate = useNavigate();
  const org = orden?.origen_resurtido;
  if (!org || org.tipo !== "surtido_cedis" || !org.traspaso_id) return null;
  const ir = () => navigate(`/traspasos?surtir=${org.traspaso_id}`);
  if (compacto) return <button data-testid={`oc-surtir-cedis-${orden.folio}`} onClick={ir} className="btn-soft h-7 px-2 text-[11px]"><Truck className="w-3 h-3 text-brand-amber" /> Surtir {org.folio}</button>;
  return (
    <div className="rounded-xl border border-brand-amber-line bg-brand-amber-soft/50 px-4 py-3 flex items-center justify-between gap-3 flex-wrap" data-testid="oc-atajo-surtir-cedis">
      <div className="text-xs text-brand-ink"><b>Compra para el pedido CEDIS {org.folio}</b> · cuando la mercancía esté en Almacén Central, surte el faltante y decide si envías parcial o consolidado.</div>
      <button data-testid="oc-ir-surtir-faltante" onClick={ir} className="h-8 px-3 rounded-full text-xs font-bold bg-brand-amber text-brand-ink hover:brightness-95 flex items-center gap-1"><Truck className="w-3.5 h-3.5" /> Surtir faltante de {org.folio}</button>
    </div>
  );
}
